import {useState} from 'react';
import {Input} from 'antd';

const {TextArea} = Input;

export const TextChangeWidget = ({text, onTextSave, maxLength, rows, placeholder="NoText", props}) => {
    const [active, setActive] = useState(false);
    const [value, setValue] = useState(undefined);

    const onClick = () => {
        setValue(text)
        setActive(true);
    }

    const onChange = (e) => {
        setValue(e.target.value);
    }

    const sendName = () => {
        if (onTextSave) {
            // do not allow empty string
            const newValue = (value === "") ? placeholder : value
            onTextSave(newValue);
        }
    }

    const onBlur = () => {
        sendName();
        setActive(false);
    }

    const onMouseLeave = () => {
        sendName();
        setActive(false);
    }

    const divStyle = {
        cursor: 'pointer'
    }

    const displayText = (text && text.length > 0) ? text : placeholder;

    if (active === false) {
        return <div style={divStyle} onClick={onClick}>
            {displayText}
        </div>
    } else {
        return <TextArea maxLength={maxLength} rows={rows} value={value} onChange={onChange} onBlur={onBlur} onMouseLeave={onMouseLeave}/>
    }
}